import { render, staticRenderFns } from "./showEditComponent.vue?vue&type=template&id=71247fa2&"
import script from "./showEditComponent.vue?vue&type=script&lang=ts&"
export * from "./showEditComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports